import * as THREE from 'three'
import Sizes from "./Utils/Sizes"
import Time from "./Utils/Time"
import Camera from './Camera'
import Renderer from './Renderer'
import World from './World/World'
import Resources from './Utils/Resources'
import Debug from './Utils/Debug'
import Quality from './Utils/Quality'
import sources from './sources'
import LoadingScreen from './LoadingScreen/LoadingScreen'
import InteractionManager from './Utils/InteractionManager'


let instance = null

export default class Experience
{
  constructor(canvas)
  {
    if (instance)
    {
      return instance
    }
    instance = this

    window.experience = this
    this.canvas = canvas

    // Setup (生成する順番を考慮すること、他のクラスをインスタンスの中で参照している可能性があることに注意)
    this.debug = new Debug()
    this.sizes = new Sizes()
    this.quality = new Quality()
    this.time = new Time()
    this.scene = new THREE.Scene()
    this.resources = new Resources(sources)
    this.loadingScreen = new LoadingScreen()
    this.camera = new Camera()
    this.renderer = new Renderer()
    this.interactionManager = new InteractionManager()
    this.world = new World()

    this.sizes.on('resize', () =>
    {
      this.resize()
    })

    this.time.on('tick', () =>
    {
      this.update()
    })
  }

  // クラスのメソッドとして定義
  resize()
  {
    this.camera.resize()
    this.renderer.resize()
  }

  update()
  {
    //POINT: camera → renderer の順序で更新すること
    this.camera.update()
    this.world.update()
    this.renderer.update()
  }

  destroy()
  {
    this.sizes.off('resize')
    this.time.off('tick')

    // InteractionManagerのクリーンアップ
    if (this.interactionManager) {
      this.interactionManager.destroy()
    }

    // Remove from scene
    this.scene.traverse((child) =>
    {
      if (child instanceof THREE.Mesh)
      {
        child.geometry.dispose()
        for (const key in child.material)
        {
          const value = child.material[key]
          if (value && typeof value.dispose === 'function')
          {
            value.dispose()
          }
        }
      }
    })

    //WARNING: post-processing を使用しているときは、EffectComposer と WebGLRendererTarget なるものをDisposeする必要があるらしい
    // Remove from global scope
    this.camera.controls.dispose()
    this.renderer.instance.dispose()

    if (this.debug.active)
    {
      this.debug.ui.destroy()
    }
  }
}